import { render, staticRenderFns } from "./studentNotice.vue?vue&type=template&id=e08c2286&scoped=true"
import script from "./studentNotice.vue?vue&type=script&lang=js"
export * from "./studentNotice.vue?vue&type=script&lang=js"
import style0 from "./studentNotice.vue?vue&type=style&index=0&id=e08c2286&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e08c2286",
  null
  
)

export default component.exports